import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const MauritaniaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_15574'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_15574)'>
				<rect
					width='20'
					height='14'
					fill='#108B4D'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M14.1535 5.41339C14.1882 5.62859 14.2062 5.84923 14.2062 6.07399C14.2062 8.39359 12.2874 10.274 9.92048 10.274C7.55355 10.274 5.63477 8.39359 5.63477 6.07399C5.63477 5.84923 5.65278 5.62859 5.68747 5.41339C6.01082 7.41914 7.78289 8.95279 9.92048 8.95279C12.0581 8.95279 13.8301 7.41914 14.1535 5.41339ZM10.0009 5.99492L8.82367 6.81733L9.25802 5.46599L8.09612 4.62294L9.54177 4.61018L10.0009 3.26672L10.46 4.61018L11.9056 4.62294L10.7437 5.46599L11.1781 6.81733L10.0009 5.99492Z'
					fill='#FFC941'
				/>
			</g>
		</svg>
	);
};

export default MauritaniaFlagIcon;
